import axios from 'axios';

export const loginControlApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/login-control`,
    headers: {
        'Content-Type': 'application/json'
    }
})